<ng-container *ngIf="!notEnoughMilesFlag">
    <div class="extras-miles-info__container" [ngClass]="{'not-available ': hasLoggin && (milesNeeded > userMiles) && INDRA_hasAddedExtras(), 'is-selected': payExtrasWithMilesStatus  && INDRA_hasAddedExtras()}">
        <app-svg class="general extras-miles-info__icon" [alt]="'extrasSidebar.useMilesInfo.alt.milesIcon' | ibeadmin | async" [svg]="'icons.svg#miles_and_go--manage_miles'" *ngIf="!hasLoggin || (hasLoggin && !INDRA_hasAddedExtras()) || (hasLoggin && (userMiles < milesNeeded)) || milesNeeded <= 0">
        </app-svg>

        <p class="extras-miles-info__text" *ngIf="!hasLoggin">
            <a href="javascript:;" class="link" (click)=INDRA_handleLogin()>{{ 'extrasSidebar.useMilesInfo.text.login' | ibeadmin | async }}</a> {{ 'extrasSidebar.useMilesInfo.text.ifYouWantToPay' | ibeadmin | async }}
        </p>
        <p class="extras-miles-info__text" *ngIf="hasLoggin && !INDRA_hasAddedExtras() || (hasLoggin && milesNeeded <= 0)">
            {{ 'extrasSidebar.useMilesInfo.text.youWillHaveTheOption' | ibeadmin | async }}
        </p>
        <p class="extras-miles-info__text" *ngIf="hasLoggin && (userMiles < milesNeeded) && INDRA_hasAddedExtras()">
            {{ 'extrasSidebar.useMilesInfo.text.youDontHaveEnoughMiles' | ibeadmin | async }} <br /> {{ 'extrasSidebar.useMilesInfo.text.keepFlyingWithTapToEarn' | ibeadmin | async }}
        </p>


        <label *ngIf="hasLoggin && INDRA_hasAddedExtras() && (userMiles > milesNeeded) && milesNeeded > 0" class="extras-miles-info__checkbox checkbox-wrapper" role="checkbox">
		<input  
			(change)="INDRA_useMilesChange($event)" 
			[(ngModel)]="payExtrasWithMilesStatus" 
			type="checkbox" 
			class="checkbox" 
			>
		<span><label>{{ 'extrasSidebar.useMilesInfo.text.use' | ibeadmin | async }} {{ milesNeeded }} {{ 'extrasSidebar.useMilesInfo.text.ofYourMiles' | ibeadmin | async }}</label></span>
        </label>


        <!-- <app-checkbox-input class="extras-miles-info__checkbox" *ngIf="hasLoggin && INDRA_hasAddedExtras() && 
		(userMiles > milesNeeded)" [label]="'Use ' + milesNeeded + promoCoin + ' of your miles to pay for this extra'" 
		(change)="INDRA_useMilesChange($event)" [checked]="payExtrasWithMilesStatus"
	></app-checkbox-input>
	-->
    </div>
</ng-container>

<ng-container *ngIf="payExtrasWithMilesStatus && notEnoughMilesFlag">
    <div class="extras-miles-info__container" [ngClass]="{'not-available ': true, 'is-selected': false}">
        <app-svg class="general extras-miles-info__icon" [alt]="'extrasSidebar.useMilesInfo.alt.milesIcon' | ibeadmin | async" [svg]="'icons.svg#miles_and_go--manage_miles'">
        </app-svg>

        <p class="extras-miles-info__text">
            {{ 'extrasSidebar.useMilesInfo.text.youDontHaveEnoughMiles' | ibeadmin | async }} <br /> {{ 'extrasSidebar.useMilesInfo.text.keepFlyingWithTapToEarn' | ibeadmin | async }}
        </p>

    </div>
</ng-container>